import { ChangeDetectionStrategy, Component, forwardRef, Input } from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import { UrlInputComponent } from "./url-input.component";

@Component({
  selector: "lib-url-input-extended",
  templateUrl: "./url-input-extended.component.html",
  styleUrls: ["./url-input-extended.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => UrlInputExtendedComponent),
      multi: true
    }
  ]
})
export class UrlInputExtendedComponent extends UrlInputComponent implements ControlValueAccessor {
  @Input() isLinked = false;
  @Input() isHideTooltip = false;
  @Input() iconColor = "";
  @Input() iconInside = "";
  @Input() iconInsideColor = "";
  @Input() iconSvg = "";
  @Input() urlHelpTooltip = "";
  @Input() tooltipItems: string[] = [];

  @Input() override clickableIconWhenDisabled = false;
}
